import script from "./CGenericAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CGenericAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./CGenericAvatar.vue?vue&type=style&index=0&id=738e668e&lang=less"

const __exports__ = script;

export default __exports__